<template>
  <div class="mapTable">
    <div class="title">
      <span>{{ item.districtName }}</span>
    </div>
    <div id="content" class="content">
      <div class="data-table">
        <table>
          <!-- 第一行 -->
          <tr class="header">
            <td width="220px">经营收入（万元）</td>
            <td width="220px">经营利润（万元）</td>
            <td width="320px">带动村集体经济增收（万元)</td>
            <td>耕地综合利用亩数</td>
            <td>其中撂荒地亩数</td>
          </tr>
          <tr class="data">
            <td>{{ item.operatingIncome }}</td>
            <td>{{ item.operatingProfit }}</td>
            <td>{{ item.villageCollectiveIncome }}</td>
            <td>{{ item.landUseArea }}</td>
            <td>{{ item.abandonedLandArea }}</td>
          </tr>

          <!-- 第二行和第三行 -->
          <tr class="header">
            <td colspan="3" class="merged-header">劳动就业人数</td>
            <td rowspan="2" class="merged-header">主营业务</td>
            <td rowspan="2" class="merged-header">营收占比</td>
          </tr>
          <tr class="header sub-header">
            <td>一般户（人）</td>
            <td>脱贫户（人）</td>
            <td>发放工资总额（万元）</td>
          </tr>

          <!-- 最后一行数据 -->
          <tr class="data">
            <td>{{ item.generalPopulation }}</td>
            <td>{{ item.povertyPopulation }}</td>
            <td>{{ item.laborRemuneration }}</td>
            <td>{{ item.business }}</td>
            <td>{{ item.revenue }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { areaSaleTotal } from '@/api/agriculture-dashboard'
import to from 'await-to'
export default {
  name: 'DataTable',
  data() {
    return {
      colData: [
        { name: '经营收入（万元）', key: 'operatingIncome' },
        { name: '经营利润（万元）', key: 'operatingProfit' },
        { name: '带动村集体增收（万元）', key: 'villageCollectiveIncome' },
        { name: '耕地综合利用亩数', key: 'landUseArea' },
        { name: '其中撂荒地亩数', key: 'abandonedLandArea' },
        { name: '一般户（人）', key: 'generalPopulation' },
        { name: '脱贫户（人）', key: 'povertyPopulation' },
        { name: '发放工资总额（万元）', key: 'laborRemuneration' },
      ],

      item: {},

      activeIndex: 0,
      areaList: [],
      timer: null,
      changeTime: 8000,
    }
  },
  async mounted() {
    await this.initData()
    this.setChange()
    // this.timer = setInterval(() => {
    //   this.setChange()
    // }, this.changeTime)
    // setInterval(() => {
    //   this.initData()
    // }, process.env.VUE_APP_LTIME)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async initData() {
      const [res, err] = await to(areaSaleTotal())
      if (err) return
      this.areaList = res.data
      console.log(`output->this.`, this.areaList)
    },
    setChange() {
      console.log(`output->this.item`, this.item)
      if (this.activeIndex < this.areaList.length - 1) this.activeIndex++
      else this.activeIndex = 0
      this.item = this.areaList[this.activeIndex]
      console.log(`output->this.item`, this.item)
      // 触发事件通知父组件更新地图选中状态
      this.$emit('change', this.item)
    },
    // 外部调用切换指定索引的数据
    setActiveIndex(index) {
      if (index >= 0 && index < this.areaList.length) {
        this.activeIndex = index
        this.item = this.areaList[index]
        // 触发事件通知父组件更新地图选中状态
        this.$emit('change', this.item)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mapTable {
  // position: relative;
  width: 1592px;
  height: 403px;
  box-sizing: border-box;
  background: url('~@/img/agriculture/table_bg.png') no-repeat;
  background-size: 100% 100%;
  padding: 5px 60px 0;
  margin: 0 auto;

  .title {
    width: 550px;
    position: relative;
    font-size: 34px;
    color: rgba(226, 239, 255, 0.9);
    letter-spacing: 0.2em;
    font-style: italic;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    text-shadow: 0px 0px 6px #4c77ef;
  }
}

.content {
  height: calc(100% - 80px);
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.data-table {
  width: 100%;
  margin: 0 auto;
  font-size: 24px;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: transparent;
  color: rgba(226, 239, 255, 0.9);
  table-layout: fixed;
  font-size: 24px;
  border: 1px solid #fff;
  border-radius: 5px;
  overflow: hidden;
}

td {
  border: 1px solid #fff;
  text-align: center;
  padding: 0px 10px;
  vertical-align: middle;
  line-height: 1.4;
}

.header {
  td {
    color: rgba(226, 239, 255, 0.9);
    text-shadow: 0px 0px 6px #4c77ef;
  }

  .merged-header {
    color: rgba(226, 239, 255, 0.9);
    font-size: 24px;
    text-shadow: 0px 0px 6px #4c77ef;
  }
}

.sub-header {
  td {
    color: rgba(226, 239, 255, 0.9);
    font-size: 24px;
    text-shadow: 0px 0px 6px #4c77ef;
  }
}

.data {
  td {
    color: rgba(226, 239, 255, 0.9);
    cursor: pointer;
    transition: all 0.25s ease;
    text-shadow: 0px 0px 6px #4c77ef;

    &:hover {
      color: rgba(226, 239, 255, 0.9);
    }
  }
}
</style>
